import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceOptions } from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import notify from 'devextreme/ui/notify';
import dxScheduler, { dxSchedulerAppointment } from 'devextreme/ui/scheduler';
import { compact, head, isEmpty, isNil, round, uniq, uniqBy } from 'lodash-es';
import fromPairs from 'lodash-es/fromPairs';
import last from 'lodash-es/last';
import sum from 'lodash-es/sum';
import moment, { utc } from 'moment';
import { combineLatest, from, iif, of } from 'rxjs';
import { catchError, concatMap, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { DxCellPreparedEvent, DxToolbarPreparingEvent } from '../../../../core/dx.types';
import {
  getDistinctFromArr$,
  gqlMongoLoad,
} from '../../../../shared/classes/loopback-custom-store/generic/store.utils';
import { hAll } from '../../../../shared/classes/utils/utils';
import { CommonService } from '../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { PusherService } from '../../../../shared/modules/my-common/services/pusher.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { DlgShowJsonComponent } from '../../../../shared/modules/ui/components/dlg-show-json/dlg-show-json.component';
import { FilterJson } from '../../../../shared/modules/ui/pipes/filter-json.pipe';
import { GridHelperService } from '../../../../shared/modules/ui/services/grid-helper.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import {
  ActiveClientSignatureView,
  ActiveClientSignatureViewApi,
  AuthService,
  AuthServiceApi,
  Consumer,
  ConsumerApi,
  Facility,
  LoggerService,
  MyUtils,
  MyUtilsApi,
} from '../../../../shared/sdk';
import { DlgEditClaimV2Component } from '../../dialogs/dlg-edit-claim-v2/dlg-edit-claim-v2.component';
import { DlgEditClaimComponent } from '../../dialogs/dlg-edit-claim/dlg-edit-claim.component';
import { AuthClaimService } from '../../services/auth-claim.service';
import { IAuthMember, INavinetAuthDoc, TAppMealClaimSet } from '../../services/auth-claim.type';

@Component({
  selector: 'app-meals',
  templateUrl: './auth-claim.component.html',
  styleUrls: ['./auth-claim.component.scss'],
  providers: [AuthClaimService],
})
export class AuthClaimComponent extends ABaseComponent implements OnInit {
  @ViewChild('memberGrid', { static: false }) memberGrid: DxDataGridComponent;
  @ViewChild('authGrid', { static: false }) authGrid: DxDataGridComponent;
  @ViewChild('statusGrid', { static: false }) statusGrid: DxDataGridComponent;
  @ViewChild('hhaStatusGrid', { static: false }) hhaStatusGrid: DxDataGridComponent;
  @ViewChild('scheduler', { static: false }) scheduler: DxSchedulerComponent;

  public procedureCodes = this.service.getProcedureCodes();
  public claimStatusDs$ = of([]);
  public claimStatusSrcDs$ = of([]);
  public e9yCodeDs$ = of([]); // getDistinct$(this.dss, 'StediEligibilityDataCache', 'response.tradingPartnerServiceId');
  public e9yNameDs$ = of([]); // getDistinct$(this.dss, 'StediEligibilityDataCache', 'response.payer.name');
  public mcoDs$ = of([]);

  grid_stateStoring: any;
  authGrid_stateStoring: any;
  nnClaims_stateStoring: any;
  hhaClaims_stateStoring: any;

  resourceDs: {
    text: string;
    id: string;
    color: string;
  }[];

  scheduler_ctxMenuDisabled: boolean;
  scheduler_ctxMenuItems: any[];

  dataSources: {
    // e9ies: IStediE9yDoc[];
    authsPrev: INavinetAuthDoc[];
    authsNext: INavinetAuthDoc[];
    auths: INavinetAuthDoc[];
    clSet: TAppMealClaimSet[];
    signs: ActiveClientSignatureView[];
    nnClaims: { _id }[];
    hhaClaims: { _id }[];
    chcStatuses: { _id; claims: Dictionary<any> }[];
  } = {
    // e9ies: [],
    authsPrev: [],
    authsNext: [],
    auths: [],
    clSet: [],
    signs: [],
    nnClaims: [],
    hhaClaims: [],
    chcStatuses: [],
  };

  facilityDso: DataSourceOptions = [];
  memberDso: DataSourceOptions = [];
  // e9yDso: Dictionary<IStediE9yDoc> = {};
  clSetDso: Dictionary<TAppMealClaimSet> = {};
  authDso: DataSourceOptions;
  nnClaimsDso: DataSourceOptions;
  hhaClaimsDso: DataSourceOptions;

  private dsCollection: string;

  selectedDate: Date = moment().subtract(1, 'month').toDate();
  // maxDate: Date = moment().subtract(1, 'month').endOf('month').toDate();

  selectedCodes: string[] = [];
  withSignsOnly = false;
  selectedMember: IAuthMember;
  auths_selectedRowKeys: string[] = [];

  get moments() {
    const m = moment(this.selectedDate);
    return {
      yyyymm: Number(m.clone().format('YYYYMM')),
      som: m.clone().startOf('month'),
      eom: m.clone().endOf('month'),
      somw: m.clone().startOf('month').startOf('week'),
      eomw: m.clone().endOf('month').endOf('week'),
    };
  }

  min: Date = this.moments.som.toDate();
  max: Date = this.moments.eom.toDate();

  appointments: dxSchedulerAppointment[] = [];
  selectedPeriod: string[] = [];

  counters: Dictionary<{ a: number; s: number; c1: number; c2: number }>;
  subCounters: Dictionary<{ a: number; s: number; c1: number; c2: number }>;

  constructor(
    public logger: LoggerService,
    public config: ConfigService,
    public common: CommonService,
    private ui: UiService,
    private dss: DataSourceService,
    private api: AuthServiceApi,
    private dialog: MatDialog,
    private gridHelper: GridHelperService,
    protected pusher: PusherService,
    private service: AuthClaimService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: 'e279feb0-ca02-40fc-b2e1-440051510cb5',
    };

    this.authGrid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '7c013900-9cb0-4425-b6a7-c0e456fc3240',
    };

    this.nnClaims_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '08cc0151-98f5-4c01-8382-76f2a65c702f',
    };

    this.hhaClaims_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '10e8ddfc-c510-4bef-8fc3-3284df010186',
    };

    this.resourceDs = this.service.getResourceDataSet();

    this.counters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));
    this.subCounters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));

    this.facilityDso = this.buildFacilityDataSource();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  dateBox_onValueChanged(e) {
    this.selectedDate = e.value;
  }

  codeBox_onValueChanged(e) {
    this.selectedCodes = e.value;
  }

  filter_onClick(e) {
    this.memberGrid.instance.selectRows([], false);
    this.authGrid.instance.selectRows([], false);

    this.min = this.moments.som.toDate();
    this.max = this.moments.eom.toDate();

    void this.buildDataSource();
  }

  // async fillChcEligibility() {
  //   const date = this.moments.som.format('YYYY-MM-DD');
  //
  //   this.ui.showLoading();
  //   await this.config
  //     .hasAnyRole$(['SU', 'BILLER'])
  //     .pipe(
  //       switchMap(hasRole =>
  //         iif(() => hasRole, this.pusher.rpc('FILL_CHC_ELIGIBILITIES', { date, useRunJob: true }, hAll), of(null)),
  //       ),
  //       catchError(err => of(notify(err.message, 'error', 5000))),
  //       tap(() => this.ui.hideLoading()),
  //     )
  //     .toPromise();
  // }

  async processClaims(preBuildOnly = false, buildOnly = false) {
    if (this.selectedCodes.length !== 1) return notify('Please select single Procedure Code', 'error', 5000);

    this.ui.showLoading();
    await this.config
      .hasAnyRole$(['SU'])
      .pipe(
        switchMap(hasRole =>
          iif(
            () => hasRole,
            this.pusher.rpc(
              'PROCESS_MEAL_CLAIMS',
              {
                yyyymm: this.moments.yyyymm,
                code: this.selectedCodes[0],
                preBuildOnly,
                buildOnly,
                useRunTask: true,
              },
              hAll,
            ),
            of(null),
          ),
        ),
        catchError(err => of(notify(err.message, 'error', 5000))),
        tap(() => this.ui.hideLoading()),
      )
      .toPromise();
  }

  async processClaimsStatuses() {
    // if (this.selectedCodes.length !== 1) return notify('Please select single Procedure Code', 'error', 5000);

    this.ui.showLoading();
    await this.config
      .hasAnyRole$(['SU'])
      .pipe(
        switchMap(hasRole =>
          iif(
            () => hasRole,
            this.pusher.rpc(
              'PROCESS_MEAL_CLAIM_STATUSES',
              {
                yyyymm: this.moments.yyyymm,
                // code: this.selectedCodes[0],
                useRunJob: true,
              },
              hAll,
            ),
            of(null),
          ),
        ),
        catchError(err => of(notify(err.message, 'error', 10_000))),
        tap(() => this.ui.hideLoading()),
      )
      .toPromise();
  }

  async getEraFiles() {
    // if (this.selectedCodes.length !== 1) return notify('Please select single Procedure Code', 'error', 5000);

    this.ui.showLoading();
    await this.config
      .hasAnyRole$(['SU', 'BILLER'])
      .pipe(
        switchMap(hasRole =>
          iif(
            () => hasRole,
            this.pusher.rpc(
              'GET_ERA_FILES',
              {
                yyyymm: this.moments.yyyymm,
                // code: this.selectedCodes[0],
                useRunJob: true,
              },
              hAll,
            ),
            of(null),
          ),
        ),
        catchError(err => of(notify(err.message, 'error', 10_000))),
        tap(() => this.ui.hideLoading()),
      )
      .toPromise();
  }

  grid_onInitialized(e) {
    this.gridHelper.handle(e.component, {
      flatToTreeObject: false,
      copyIdsOnSaving: false,
      selectRowOnEdit: false,
      notifyErrors: true,
      onGridRefresh: () => {
        void this.buildDataSource();
      },
    });

    // void this.buildDataSource();
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {
    (e.toolbarOptions.items as any[]).unshift(
      {
        name: 'selectDate',
        locateInMenu: 'auto',
        widget: 'dxDateBox',
        location: 'before',
        sortIndex: 0,
        showText: 'inMenu',
        options: {
          firstDayOfWeek: 1,
          calendarOptions: {
            maxZoomLevel: 'year',
            minZoomLevel: 'decade',
          },
          value: this.selectedDate,
          displayFormat: 'MMMM yyyy',
          pickerType: 'calendar',
          type: 'date',
          useMaskBehavior: true,
          onValueChanged: this.dateBox_onValueChanged.bind(this),
        },
      },
      {
        name: 'selectCode',
        locateInMenu: 'auto',
        widget: 'dxTagBox',
        location: 'before',
        sortIndex: 0,
        showText: 'inMenu',
        options: {
          value: this.selectedCodes,
          multiline: false,
          wrapItemText: true,
          dataSource: this.service.getProcedureCodes(),
          onValueChanged: this.codeBox_onValueChanged.bind(this),
        },
      },
      // {
      //   name: 'withSigns',
      //   locateInMenu: 'auto',
      //   widget: 'dxSwitch',
      //   location: 'before',
      //   sortIndex: 0,
      //   showText: 'always',
      //   options: {
      //     width: '60px',
      //     switchedOnText: 'Has Signs',
      //     switchedOffText: 'All',
      //     value: this.withSignsOnly,
      //     onValueChanged: $e => (this.withSignsOnly = $e.value),
      //   },
      // },
      {
        name: 'filter',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'before',
        sortIndex: 0,
        showText: 'always',
        options: {
          icon: 'fas fa-filter',
          text: 'Filter',
          hint: 'Filter',
          onClick: this.filter_onClick.bind(this),
        },
      },
      // {
      //   name: 'fillChcE9y',
      //   locateInMenu: 'auto',
      //   widget: 'dxButton',
      //   location: 'after',
      //   sortIndex: 30,
      //   showText: 'always',
      //   options: {
      //     icon: 'fas fa-fill',
      //     text: 'Fill E9y',
      //     hint: 'Fill All Members Eligibility from CHC for the selected month',
      //     onClick: () => this.fillChcEligibility(),
      //   },
      // },
      {
        name: 'buildClaims',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-claim',
          text: 'Build Claims',
          hint: 'Build Meal Claims for the selected month',
          onClick: () => this.processClaims(false, true),
        },
      },
      {
        name: 'processClaims',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-claim',
          text: 'Process Claims',
          hint: 'Process Meal Claims for the selected month',
          onClick: () => this.processClaims(),
        },
      },
      {
        name: 'processClaimsStatuses',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-claims-statuses',
          text: 'Process Claims Statuses',
          hint: 'Process Meal Claims Statuses for the selected month',
          onClick: () => this.processClaimsStatuses(),
        },
      },
      {
        name: 'getEraFiles',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-era-files',
          text: 'Get ERA files',
          hint: 'Get ERA files for the selected month',
          onClick: () => this.getEraFiles(),
        },
      },
    );
  }

  grid_onCellPrepared(e: DxCellPreparedEvent<IAuthMember>) {
    if (e.rowType === 'data') {
      const remittances = oc(e).data.remittances([]);

      if (e.data.__claims_statuses.length > 0) {
        if (
          e.data.__claims_statuses.every(v =>
            [
              ...['SUBMITTED', 'ACCEPTED', 'PENDED', 'PAID', 'REJECTED'],
              ...['Acknowledgement', 'Pending', 'Finalized', 'Requests'],
            ].some(s => v.includes(s)),
          )
        ) {
          e.cellElement.classList.add('meal-cell-violet');
        }

        if (
          e.data.__claims_statuses.every(v =>
            [
              ...['ACCEPTED', 'PENDED', 'PAID', 'REJECTED'],
              ...['Acknowledgement', 'Pending', 'Finalized', 'Requests'],
            ].some(s => v.includes(s)),
          )
        ) {
          e.cellElement.classList.add('meal-cell-blue');
        }

        if (e.data.__claims_statuses.every(v => v.includes('PAID'))) {
          e.cellElement.classList.add('meal-cell-green');
        }

        if (e.data.__claims_statuses.some(v => ['Finalized', 'Requests'].some(s => v.includes(s)))) {
          e.cellElement.classList.add('meal-cell-brown');
        }

        if (e.data.__claims_statuses.some(v => v.includes('FAILED'))) {
          e.cellElement.classList.add('meal-cell-brown');
        } else if (e.data.__claims_statuses.some(v => v.includes('PARTIAL')))
          e.cellElement.classList.add('meal-cell-brown');
        else if (e.data.__claims_statuses.some(v => v.includes('REJECTED'))) {
          e.cellElement.classList.add('meal-cell-red');
        }
      }

      if (
        remittances.length > 0 &&
        e.data.__paidAmount > 0 &&
        e.data.__submittedAmount > 0 &&
        e.data.__submittedAmount - e.data.__adjustmentAmount === e.data.__paidAmount
      ) {
        e.cellElement.classList.add('meal-cell-green');
      }
    }
  }

  grid_onSelectionChanged(e) {
    this.selectedMember = e.selectedRowsData[0];
    this.memberGrid.instance.beginCustomLoading('Loading...');
    void this.fillUpMemberData().finally(() => this.memberGrid.instance.endCustomLoading());
  }

  grid_onContextMenuPreparing(e) {
    if (e.row && e.row.rowType === 'data' && !e.row.isEditing) {
      const remittances = oc(e).row.data.remittances([]);
      e.items = [
        {
          text: `Get ERA PDF`,
          disabled: remittances.length === 0,
          onItemClick: async () => this.getEraPdf(remittances),
        },
      ];
    }
  }

  authGrid_onSelectionChanged(e) {
    this.auths_selectedRowKeys = e.selectedRowKeys;
    this.fillUpScheduler();
  }

  authGrid_onContextMenuPreparing(e) {
    if (e.row && e.row.rowType === 'data') {
      e.items = [
        {
          text: 'Submit Claim',
          onItemClick: async () => {
            await (e.component as dxDataGrid).selectRows([e.row.key], false);
            void this.openClaimDialog$(false, false).toPromise();
          },
        },
        {
          text: 'Submit Claim V2',
          onItemClick: async () => {
            await (e.component as dxDataGrid).selectRows([e.row.key], false);
            void this.openClaimDialog$(false, true).toPromise();
          },
        },
        {
          text: 'Claim Status',
          onItemClick: async () => {
            const clSetIds = oc(this.selectedMember)
              .claims([])
              .map(clSet => clSet._id);
            void from(clSetIds)
              .pipe(
                concatMap(claimSetId =>
                  this.dss
                    .getApi<AuthServiceApi>(AuthService)
                    .storeClaimStatus({ claimId: claimSetId, force: true })
                    .pipe(
                      concatMap(() =>
                        this.api
                          .updateAuthMemberDs(this.moments.yyyymm, this.selectedCodes, claimSetId, this.dsCollection)
                          .pipe(tap(() => this.memberGrid.instance.refresh())),
                      ),
                    ),
                ),
              )
              .toPromise();
          },
        },
      ];
    }
  }

  lastClaim(clSet: TAppMealClaimSet) {
    return last(oc(clSet).claimStack([]));
  }

  authGrid_onCellPrepared(e: DxCellPreparedEvent<INavinetAuthDoc>) {
    if (e.rowType === 'data') {
      const clSets = e.data.__claims;
      const authClStatuses = uniq(compact(clSets.map(clSet => oc(this.lastClaim(clSet))._clStatus())));

      if (
        clSets.length > 0 &&
        authClStatuses.every(v =>
          [
            ...['SUBMITTED', 'ACCEPTED', 'PENDED', 'PAID', 'REJECTED'],
            ...['Acknowledgement', 'Pending', 'Finalized', 'Requests'],
          ].some(s => v.includes(s)),
        )
      ) {
        e.cellElement.classList.add('meal-cell-blue');
      }

      if (clSets.length > 0 && authClStatuses.every(v => ['PAID'].some(s => v.includes(s)))) {
        e.cellElement.classList.add('meal-cell-green');
      }

      if (clSets.length > 0 && authClStatuses.some(v => ['Finalized', 'Requests'].some(s => v.includes(s)))) {
        e.cellElement.classList.add('meal-cell-brown');
      }

      if (clSets.length > 0 && authClStatuses.some(v => ['FAILED', 'REJECTED'].some(s => v.includes(s)))) {
        e.cellElement.classList.add('meal-cell-red');
      }

      if (e.data.__replaced) e.cellElement.classList.add('meal-cell-gray');
    }
  }

  nnClaims_onCellPrepared(e: DxCellPreparedEvent<{ ClaimStatus: string; DENYAMT: number; DISEXPCD? }>) {
    if (e.rowType === 'data') {
      if (e.data.ClaimStatus.includes('PENDED')) {
        e.cellElement.classList.add('meal-cell-violet');
      } else if (e.data.ClaimStatus.includes('ACCEPTED')) {
        e.cellElement.classList.add('meal-cell-blue');
      } else if (e.data.ClaimStatus.includes('FINALIZED')) {
        e.cellElement.classList.add('meal-cell-green');
      } else if (e.data.ClaimStatus.includes('ADJUSTED')) {
        e.cellElement.classList.add('meal-cell-green');
      }

      if (e.data.DENYAMT > 0) {
        e.cellElement.classList.add('meal-cell-brown');
      }
      if (!isEmpty(e.data.DISEXPCD)) {
        e.cellElement.classList.add('meal-cell-brown');
      }
    }
  }

  scheduler_mouseup(e) {
    if (e.button === 0) {
      this.subCounters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));

      // console.log(this.scheduler.selectedCellData);

      const dates = this.scheduler.selectedCellData.map(c => moment(c.startDate).format('YYYY-MM-DD'));
      this.selectedPeriod = [head(dates), last(dates)];

      this.subCounters = fromPairs(
        Object.keys(this.subCounters).map(k => [
          k,
          {
            a: sum(
              this.appointments
                .filter((a: any) => a.type === 'auth')
                .filter((a: any) => a.code === k)
                .filter(a => dates.includes(moment(a.startDate).format('YYYY-MM-DD')))
                .map((a: any) => a.count),
            ),
            s: sum(
              this.appointments
                .filter((a: any) => a.type === 'sign')
                .filter((a: any) => a.code === k)
                .filter(a => dates.includes(moment(a.startDate).format('YYYY-MM-DD')))
                .map((a: any) => a.count),
            ),
            c1: sum(
              this.appointments
                .filter((a: any) => a.type === 'claim')
                .filter((a: any) => a.code === k)
                .filter(a => dates.includes(moment(a.startDate).format('YYYY-MM-DD')))
                .map((a: any) => round(Number(oc(a).data.service.submittedUnits(0)))),
            ),
            c2: sum(
              this.appointments
                .filter((a: any) => a.type === 'claim')
                .filter((a: any) => a.code === k)
                .filter(a => dates.includes(moment(a.startDate).format('YYYY-MM-DD')))
                .map((a: any) => {
                  const srv = oc(a).data.service();
                  const rate = Number(oc(srv).submittedAmount(0)) / Number(oc(srv).submittedUnits(0));
                  return round(Number(oc(srv).amountPaid(0)) / rate);
                }),
            ),
          },
        ]),
      );
    }
  }

  scheduler_onAppointmentDblClick(e) {
    // console.log(e);

    e.cancel = true;

    this.dialog.open(DlgShowJsonComponent, {
      hasBackdrop: true,
      data: {
        json: e.appointmentData.data,
        title: {
          auth: 'Authorization',
          sign: 'Signature',
          claim: 'Claim Detail',
        }[e.appointmentData.type],
      },
    });
  }

  scheduler_onCellContextMenu(e) {
    // e.cancel = true;
    const scheduler = e.component as dxScheduler;

    this.scheduler_ctxMenuDisabled = false;

    this.scheduler_ctxMenuItems = [
      {
        text: 'Submit Claim',
        onItemClick: $e => {
          // console.log($e, this.schedule_selectedCellData, this.auths_selectedRowKeys);

          if (this.auths_selectedRowKeys.length !== 1) {
            return notify('Please select one Authorization', 'error', 5000);
          }

          void this.openClaimDialog$(true, false).toPromise();
        },
      },
      {
        text: 'Submit Claim V2',
        onItemClick: $e => {
          // console.log($e, this.schedule_selectedCellData, this.auths_selectedRowKeys);

          if (this.auths_selectedRowKeys.length !== 1) {
            return notify('Please select one Authorization', 'error', 5000);
          }

          void this.openClaimDialog$(true, true).toPromise();
        },
      },
    ];

    // console.log(e);
    // console.log(scheduler);
    // console.log(this.schedule_selectedCellData);
  }

  private async buildDataSource() {
    this.memberGrid.instance.beginCustomLoading('Building Dataset...');

    await this.pusher
      .rpc(
        'GET_MEAL_AUTHS_MEMBERS',
        {
          yyyymm: this.moments.yyyymm,
          codes: !isEmpty(this.selectedCodes) ? this.selectedCodes : this.procedureCodes,
          withSignsOnly: this.withSignsOnly,
          useRunTask: true,
        },
        hAll,
      )
      .pipe(
        switchMap(collection => {
          this.dsCollection = collection;

          const mongoSchema: any = {
            'last.StartDT': 'datetime',
            'last.EndDT': 'datetime',
            'last.MemberDOB': 'datetime',
            'last._ctime': 'datetime',
            'last._rtime': 'datetime',
          };

          return of({
            store: this.dss.createMongoStore(collection, mongoSchema),
          } as DataSourceOptions);
        }),
        catchError(err => {
          notify(err.message, 'error', 5000);
          return of([]);
        }),
        tap(ds => {
          this.memberDso = ds;

          this.mcoDs$ = getDistinctFromArr$(this.dss, this.dsCollection, '__mco');
          this.claimStatusDs$ = getDistinctFromArr$(this.dss, this.dsCollection, '__claims_statuses');
          this.claimStatusSrcDs$ = getDistinctFromArr$(this.dss, this.dsCollection, '__claims_statusSrc');
        }),
        tap(() => this.memberGrid.instance.endCustomLoading()),
      )
      .toPromise();

    // const collection = 'ExportsAuthsDataCache';
    // const pipeline = [
    //   {
    //     $match: {
    //       _inactive: { $ne: true },
    //
    //       Code: {
    //         $in: !isEmpty(this.selectedCode) ? this.selectedCode : this.service.getProcedureCodes(),
    //       },
    //
    //       ...(activeAuthMoment
    //         ? {
    //             StartDT: { $lte: { $date: { v: activeAuthMoment.clone().endOf('month').toDate().toISOString() } } },
    //             EndDT: { $gte: { $date: { v: activeAuthMoment.clone().startOf('month').toDate().toISOString() } } },
    //           }
    //         : {}),
    //     },
    //   },
    //   { $project: { _source: 0 } },
    //   {
    //     $sort: {
    //       StartDT: -1,
    //       _ctime: -1,
    //     },
    //   },
    //   {
    //     $group: {
    //       _id: {
    //         _broker: '$_broker',
    //         _clientId: '$_clientId',
    //       },
    //       last: { $first: '$$CURRENT' },
    //       authCount: { $count: {} },
    //     },
    //   },
    //   {
    //     $lookup: {
    //       from: 'StediEligibilityDataCache',
    //       let: { auth_memberID: '$last.MemberID' },
    //       pipeline: [
    //         {
    //           $match: {
    //             $expr: {
    //               $and: [
    //                 { $eq: ['meta.memberID', '$$auth_memberID'] },
    //                 {
    //                   $eq: ['meta.yyyymm', Number(activeAuthMoment.clone().startOf('month').format('YYYYMM'))],
    //                 },
    //               ],
    //             },
    //           },
    //         },
    //         { $project: { 'response.tradingPartnerServiceId': 1 } },
    //       ],
    //       as: 'e9y',
    //     },
    //   },
    //   {
    //     $lookup: {
    //       from: 'MealClaims',
    //       let: { auth_mci: '$last._mci' },
    //       pipeline: [
    //         {
    //           $match: {
    //             $expr: {
    //               $and: [
    //                 { $eq: ['$mci', '$$auth_mci'] },
    //                 {
    //                   $eq: ['$yyyymm', Number(activeAuthMoment.clone().startOf('month').format('YYYYMM'))],
    //                 },
    //               ],
    //             },
    //           },
    //         },
    //         { $project: { code: 1, _status: 1, authUnits: 1 } },
    //       ],
    //       as: 'claims',
    //     },
    //   },
    //   {
    //     $sort: {
    //       'last.StartDT': -1,
    //       'last._ctime': -1,
    //     },
    //   },
    // ];
    //
    // await gqlMongoLoad(this.dss, collection, {}, pipeline)
    //   .pipe(
    //     map((items: any[]) => {
    //       (items || []).forEach(itm => {
    //         itm.e9y = sortBy(
    //           uniqBy<any>((itm.e9y || []).reverse(), o => oc(o).meta.yyyymmdd()),
    //           o => oc(o).meta.yyyymmdd(),
    //         );
    //         itm.__e9y = (itm.e9y || []).map(o => oc(o).response.tradingPartnerServiceId());
    //         itm.__claims_codes = (itm.claims || []).map(o => o.code);
    //         itm.__claims_statuses = (itm.claims || []).map(o => o._status);
    //         itm.__claims_authUnits = (itm.claims || []).map(o => o.authUnits);
    //       });
    //       return items;
    //     }),
    //     tap(ds => this.$memberDso$.next(ds)),
    //     tap(() => this.memberGrid.instance.endCustomLoading()),
    //   )
    //   .toPromise();
  }

  private buildFacilityDataSource() {
    const so = this.dss.getStoreOptions(Facility, undefined, false);
    so.customFilter = {
      where: { type: { inq: ['MEALS'] } },
      order: ['typeOrder DESC', 'type', 'shortname'],
    };

    return {
      store: new CustomStore(so),
    } as DataSourceOptions;
  }

  // getE9ies$ = () => {
  //   const collection = 'StediEligibilityDataCache';
  //   const { yyyymm } = this.moments;
  //   const aggregate = [
  //     {
  //       $match: {
  //         'meta.mci': oc(this.selectedMember).last._mci(),
  //         // 'meta.memberID': oc(this.selectedMember).last.MemberID(),
  //         'meta.yyyymm': yyyymm,
  //         'status.active': true,
  //       },
  //     },
  //   ];
  //   return gqlMongoLoad<IStediE9yDoc>(this.dss, collection, { select: { 'response.x12': 0 } }, aggregate);
  // };

  getMemberAuths$ = (yyyymm?: number) => {
    yyyymm = yyyymm || this.moments.yyyymm;
    const som = utc(yyyymm + '01', 'YYYYMMDD').startOf('month');
    const sonm = som.clone().add(1, 'month');

    const lastAuth = oc(this.selectedMember).last();
    const collection = 'ExportsAuthsDataCache';
    const pipeline = [
      {
        $match: {
          Code: {
            $in: !isEmpty(this.selectedCodes) ? this.selectedCodes : this.service.getProcedureCodes(),
          },
          StartDT: { $lt: { $date: { v: utc(sonm).toISOString() } } },
          EndDT: { $gte: { $date: { v: utc(som).toISOString() } } },

          _months: yyyymm,
          _replacedMonths: { $ne: yyyymm },

          _inactive: { $ne: true },
          _valid: true,
          _mci: oc(lastAuth)._mci(),
        },
      },
      { $project: { _source: 0 } },
      {
        $sort: {
          StartDT: 1,
          _ctime: 1,
        },
      },
    ];

    return gqlMongoLoad<INavinetAuthDoc>(this.dss, collection, {}, pipeline).pipe(
      // switchMap(auths => this.api.filterAuths(auths)),
      map((auths: INavinetAuthDoc[]) => {
        auths.forEach(auth => {
          auth.__claims = oc(this.selectedMember)
            .claims([])
            .filter(cl => cl.auth._id === auth._id);
        });
        return auths;
      }),
    );
  };

  getClaimsStatuses$ = () => {
    const collection = 'ChcClaimsStatusDataCache';
    const activeAuthMoment = utc(moment(this.selectedDate).format('YYYY-MM-DD'));
    const aggregate = [
      {
        $match: {
          _tenantId: oc(this.selectedMember).last._tenantId(),
          _mci: oc(this.selectedMember).last._mci(),
          _fromServiceDate: { $date: { v: activeAuthMoment.startOf('month').toDate().toISOString() } },
        },
      },
    ];
    return gqlMongoLoad<{ _id; claims }>(this.dss, collection, {}, aggregate);
  };

  getNavinetStatuses$ = () => {
    const collection = 'Navinet_KFCHC_ClaimStatusImports';
    const { som, eom } = this.moments;
    const aggregate = [
      {
        $match: {
          SVCStartDT: { $lte: { $date: { v: eom.clone().toISOString() } } },
          SVCEndDT: { $gte: { $date: { v: som.clone().toISOString() } } },
          _mci: oc(this.selectedMember).last._mci(),
        },
      },
    ];
    return gqlMongoLoad<{ _id }>(this.dss, collection, {}, aggregate);
  };

  getHHAxStatuses$ = () => {
    const collection = 'ExportsMealsClaimsDataCache';
    const { som, eom } = this.moments;
    const authNum = oc(this.selectedMember).last.AuthNumberFacets();
    const authName = oc(this.selectedMember).last.Name();
    const authMci = oc(this.selectedMember).last._mci();

    const aggregate = [
      {
        $match: {
          $and: [
            { _date: { $gte: { $date: { v: utc(som.clone().format('YYYY-MM-DD')).toISOString() } } } },
            { _date: { $lte: { $date: { v: utc(eom.clone().format('YYYY-MM-DD')).toISOString() } } } },
            { _mci: authMci },
            // { _name: authName },
            // { _authNum: authNum },
          ],
        },
      },
    ];
    return gqlMongoLoad<{ _id }>(this.dss, collection, {}, aggregate);
  };

  getClaimSet$ = () => {
    const collection = 'MealClaims';
    const { yyyymm, som, eom } = this.moments;
    const aggregate = [
      {
        $match: {
          'meta.mci': oc(this.selectedMember).last._mci(),
          'meta.yyyymm': yyyymm,
          'meta.code': { $in: !isEmpty(this.selectedCodes) ? this.selectedCodes : this.service.getProcedureCodes() },
        },
      },
    ];
    return gqlMongoLoad<TAppMealClaimSet>(this.dss, collection, {}, aggregate);
  };

  getMemberSigns$ = () => {
    return this.dss
      .getApi<ConsumerApi>(Consumer)
      .find(
        {
          where: {
            // tenantId: oc(this.selectedMember).last._tenantId(),
            mci: oc(this.selectedMember).last._mci(),
          },
          fields: { id: true, mci: true },
          // limit: 1,
        },
        hAll,
      )
      .pipe<ActiveClientSignatureView[]>(
        switchMap((clients: Consumer[]) =>
          clients.length
            ? this.dss.getApi<ActiveClientSignatureViewApi>(ActiveClientSignatureView).find(
                {
                  where: {
                    and: [
                      { vServiceType: 'MEALS' },
                      { vdate: { gte: this.moments.somw.format('YYYY-MM-DD') } },
                      { vdate: { lte: this.moments.eomw.format('YYYY-MM-DD') } },
                      // { tenantId: this.selectedAuth._tenantId },
                      { consumerId: { inq: clients.map(c => c.id) } },
                    ],
                  },
                },
                hAll,
              )
            : of([]),
        ),
      );
  };

  openClaimDialog$ = (useCells: boolean, v2: boolean) => {
    return (
      v2
        ? this.dialog.open(DlgEditClaimV2Component, {
            hasBackdrop: true,
            width: '750px',
            data: {
              date: this.selectedDate,
              member: this.selectedMember,
              authId: this.auths_selectedRowKeys[0],
              cells: useCells ? this.scheduler.selectedCellData : [],
            },
          })
        : this.dialog.open(DlgEditClaimComponent, {
            hasBackdrop: true,
            width: '750px',
            data: {
              date: this.selectedDate,
              member: this.selectedMember,
              authId: this.auths_selectedRowKeys[0],
              cells: useCells ? this.scheduler.selectedCellData : [],
            },
          })
    )
      .afterClosed()
      .pipe(
        concatMap(claimSetId =>
          iif(
            () => !!claimSetId,
            this.api
              .updateAuthMemberDs(this.moments.yyyymm, this.selectedCodes, claimSetId, this.dsCollection)
              .pipe(tap(() => this.memberGrid.instance.refresh())),
            of(null),
          ),
        ),

        takeUntil(this.$onDestroy$),
      );
  };

  async getEraPdf(remittances: any[]) {
    const eventIds = remittances.map(r => r._eventId);

    try {
      this.ui.showLoading();
      for (const eventId of compact(uniq(eventIds))) {
        const pdfUrl = await this.dss.getApi<MyUtilsApi>(MyUtils).eraGetPdf(eventId).toPromise();
        window.open(pdfUrl);
      }
    } finally {
      this.ui.hideLoading();
    }
  }

  async fillUpMemberData() {
    this.authGrid.instance.selectRows([], false);
    this.auths_selectedRowKeys = [];
    // this.e9yDso = {};
    this.clSetDso = {};
    this.authDso = [];
    this.nnClaimsDso = [];
    this.hhaClaimsDso = [];
    this.dataSources = {
      // e9ies: [],
      authsPrev: [],
      authsNext: [],
      auths: [],
      clSet: [],
      signs: [],
      nnClaims: [],
      hhaClaims: [],
      chcStatuses: [],
    };

    this.min = this.moments.som.toDate();
    this.max = this.moments.eom.toDate();

    this.appointments = [];

    this.counters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));
    this.subCounters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));

    if (this.selectedMember) {
      await combineLatest([
        // this.getE9ies$(),
        of([]),

        // this.getMemberAuths$(Number(this.moments.som.subtract(1, 'month').format('YYYYMM'))).toPromise(),
        of([]),

        // this.getMemberAuths$(Number(this.moments.som.add(1, 'month').format('YYYYMM'))).toPromise(),
        of([]),

        this.getMemberAuths$(),
        this.getClaimSet$(),
        this.getMemberSigns$(),
        this.getNavinetStatuses$(),
        this.getHHAxStatuses$(),
        this.getClaimsStatuses$(),
      ])
        .pipe(
          tap(([e9ies, authsPrev, authsNext, auths, clSet, signs, nnClaims, hhaClaims, chcStatuses]) => {
            this.dataSources = { authsPrev, authsNext, auths, clSet, signs, nnClaims, hhaClaims, chcStatuses };
          }),
          tap(() => {
            // this.e9yDso = fromPairs(
            //   uniqBy(
            //     sortBy(oc(this.dataSources.e9ies)([]), o => oc(o).meta.yyyymmdd()),
            //     o => oc(o).meta.payerID(),
            //   ).map((o: IStediE9yDoc) => [
            //     [oc(o).response.tradingPartnerServiceId(), oc(o).response.payer.name()].join(':'),
            //     o,
            //   ]),
            // );

            this.authDso = this.dataSources.auths.filter(
              auth =>
                utc(auth.StartDT).isSameOrBefore(utc(this.moments.eom.format('YYYY-MM-DD'))) &&
                utc(auth.EndDT).isSameOrAfter(utc(this.moments.som.format('YYYY-MM-DD'))),
            );

            this.clSetDso = fromPairs(
              this.dataSources.clSet.map((clSet: TAppMealClaimSet) => [
                [
                  isNaN(Number(oc(this.lastClaim(clSet)).userId())) ? 'a' : 'u',
                  oc(clSet).meta.code(),
                  oc(this.lastClaim(clSet)).request.tradingPartnerServiceId(),
                  oc(this.lastClaim(clSet))._clStatus(),
                ].join(':'),
                clSet,
              ]),
            );

            this.nnClaimsDso = this.dataSources.nnClaims;
            this.hhaClaimsDso = this.dataSources.hhaClaims;

            this.fillUpScheduler();
          }),
        )
        .toPromise();
    }
  }

  fillUpScheduler() {
    this.min = this.moments.som.toDate();
    this.max = this.moments.eom.toDate();

    this.appointments = [];

    this.counters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));
    this.subCounters = fromPairs(this.service.getProcedureCodes().map(code => [code, { a: 0, s: 0, c1: 0, c2: 0 }]));

    const { auths, signs, chcStatuses } = this.dataSources;

    const keys = this.authGrid.instance.getSelectedRowKeys();
    const isFiltered = keys.length > 0;

    const filteredAuths = auths
      .filter(auth => (isFiltered ? keys.includes(auth._id) : !auth.__replaced))
      .filter(auth => !isEmpty(oc(auth)._manifest({})));

    const filteredCodes = uniq(filteredAuths.map(auth => auth.Code));

    const _map1 = {
      Su: 'Su',
      Mo: 'M',
      Tu: 'T',
      We: 'W',
      Th: 'Th',
      Fr: 'F',
      Sa: 'Sa',
    };

    const _map2 = {
      HOT: 'W1759',
      FROZEN: 'W1760',
      SANDWICH: 'W1761',
      EMERGENCY: 'W1762',
      SPECIAL: 'W1764',
    };

    const appointmentsAuth: dxSchedulerAppointment[] = [];
    uniqBy(filteredAuths, auth =>
      [
        auth.AuthNumberFacets,
        auth.Code,
        utc(auth.StartDT).format('YYYY-MM-DD'),
        utc(auth.EndDT).format('YYYY-MM-DD'),
      ].join('-'),
    ).forEach(auth => {
      const rrule = this.service.getAuthRRule(auth);
      rrule.all().forEach(d =>
        appointmentsAuth.push({
          data: auth,
          type: 'auth',
          code: auth.Code,
          count: oc(auth)._manifest({})[_map1[moment(d).format('dd')]] || 0,
          rescode: 'a:' + auth.Code,
          //
          visible: true,
          allDay: true,
          startDate: moment(d).format('YYYY-MM-DD'),
          endDate: moment(d).format('YYYY-MM-DD'),
          text: `A:${auth.Code}: ` + oc(auth)._manifest({})[_map1[moment(d).format('dd')]],
          description: Object.entries(new FilterJson().transform(auth))
            .map(([k, v]) => `${k}: ${v}`)
            .join('\n'),
        } as dxSchedulerAppointment),
      );
    });

    const appointmentsSign = [];
    signs.forEach(s => {
      Object.entries(s.meta.mealDroppedCountList)
        .filter(([k, v]) => (isFiltered ? filteredCodes.includes(oc(_map2[k])(k)) : true))
        .filter(([k, v]) => !isNil(v) && v > 0)
        .forEach(([k, v]) =>
          appointmentsSign.push({
            data: s,
            type: 'sign',
            code: oc(_map2[k])(k),
            count: oc(v)(0),
            rescode: 's' + (s.validationState === 'VALID' ? ':' : '?:') + oc(_map2[k])(k),
            //
            visible: true,
            allDay: true,
            startDate: s.vdate,
            endDate: s.vdate,
            text: `S${s.validationState === 'VALID' ? '' : '?'}:${oc(_map2[k])(k)}: ${v}`,
            description: [].join('\n'),
          } as dxSchedulerAppointment),
        );
    });

    const appointmentsClStatus = [];
    chcStatuses.forEach(clDoc => {
      (oc(clDoc).claims([]) as any[]).forEach(cl => {
        const clDates = (oc(cl).claimStatus.claimServiceDate('') as string)
          .split('-')
          .filter(p => !isEmpty(p))
          .map(p => moment(p, 'YYYYMMDD').format('YYYY-MM-DD'));

        (oc(cl).serviceDetails([]) as any[])
          .filter(sd => (isFiltered ? filteredCodes.includes(oc(sd).service.procedureId()) : true))
          .forEach(sd => {
            const srv = oc(sd).service();

            const rate = Number(oc(srv).submittedAmount(0)) / Number(oc(srv).submittedUnits(0));
            const paidUnits = round(Number(oc(srv).amountPaid(0)) / rate);

            appointmentsClStatus.push({
              data: sd,
              type: 'claim',
              code: oc(srv).procedureId(),
              count: Number(oc(srv).submittedUnits(0)),
              rescode: 'c:' + oc(srv).procedureId(),
              //
              visible: true,
              allDay: true,
              startDate: head(clDates),
              endDate: last(clDates),
              text: `C:${oc(srv).procedureId()}: ${Number(oc(srv).submittedUnits(0))}/${paidUnits}`,
              description: [].join('\n'),
            } as dxSchedulerAppointment);
          });
      });
    });

    this.appointments = [...appointmentsAuth, ...appointmentsSign, ...appointmentsClStatus];

    this.counters = fromPairs(
      Object.keys(this.counters).map(k => [
        k,
        {
          a: sum(
            this.appointments
              .filter((a: any) => a.type === 'auth')
              .filter((a: any) => a.code === k)
              .filter(a => moment(a.startDate).format('YYYYMM') === '' + this.moments.yyyymm)
              .map((a: any) => a.count),
          ),
          s: sum(
            this.appointments
              .filter((a: any) => a.type === 'sign')
              .filter((a: any) => a.code === k)
              .filter(a => moment(a.startDate).format('YYYYMM') === '' + this.moments.yyyymm)
              .map((a: any) => a.count),
          ),
          c1: sum(
            this.appointments
              .filter((a: any) => a.type === 'claim')
              .filter((a: any) => a.code === k)
              .filter(a => moment(a.startDate).format('YYYYMM') === '' + this.moments.yyyymm)
              .map((a: any) => round(Number(oc(a).data.service.submittedUnits(0)))),
          ),
          c2: sum(
            this.appointments
              .filter((a: any) => a.type === 'claim')
              .filter((a: any) => a.code === k)
              .filter(a => moment(a.startDate).format('YYYYMM') === '' + this.moments.yyyymm)
              .map((a: any) => {
                const srv = oc(a).data.service();
                const rate = Number(oc(srv).submittedAmount(0)) / Number(oc(srv).submittedUnits(0));
                return round(Number(oc(srv).amountPaid(0)) / rate);
              }),
          ),
        },
      ]),
    );
  }

  e9y_calculateFilterExpression = function (filterValue, selectedFilterOperation, target) {
    const column = this as any;
    // console.log(column.dataField, filterValue, selectedFilterOperation, target);

    if (isNil(filterValue)) {
      filterValue = [];
    }

    // if (selectedFilterOperation === '=') {
    //     const filterExpression = [['__e9y', 'contains', filterValue]];
    //     return filterExpression;
    // }

    return column.defaultCalculateFilterExpression(filterValue, selectedFilterOperation, target);
  };

  claims_calculateFilterExpression = function (filterValue, selectedFilterOperation, target) {
    const column = this as any;
    // console.log(column.dataField, filterValue, selectedFilterOperation, target);

    if (isNil(filterValue)) {
      filterValue = [];
    }

    // if (selectedFilterOperation === '=') {
    //     const filterExpression = [
    //       ['__claims_codes', 'contains', filterValue],
    //       'or',
    //       ['__claims_statuses', 'contains', filterValue],
    //       'or',
    //       ['__claims_authUnits', 'contains', filterValue],
    //     ];
    //     return filterExpression;
    // }

    return column.defaultCalculateFilterExpression(filterValue, selectedFilterOperation, target);
  };

  mco_calculateFilterExpression = function (filterValue, selectedFilterOperation, target) {
    const column = this as any;
    // console.log(column.dataField, filterValue, selectedFilterOperation, target);

    if (isNil(filterValue)) {
      filterValue = [];
    }

    return column.defaultCalculateFilterExpression(filterValue, selectedFilterOperation, target);
  };

  schedulerCtxMenu_onItemClick(e) {
    e.itemData.onItemClick(e);
  }

  schedulerCtxMenu_onHiding() {
    this.scheduler_ctxMenuItems = [];
  }

  splitter_sizeChange(e) {
    this.scheduler.instance.repaint();
  }
}
